import { Box } from "@mui/material";
import {
  Tabs
} from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { SalonAPI } from "../../../api/Salon";
import InfoTab from "../InfoTab";
import Photos from "../Photos";
import { Settings } from "../Settings";

const AddSalon = () => {
  const [infoData, setInfoData] = useState<SalonInfo | null>(null);
  const [photoData, setPhotoData] = useState<PhotosSalon>({
    featured_photo: "",
    photos: [],
  });
  const [settingData, setSettingData] = useState<SalonSetting>({
    email: "",
    payment_method_limit: "",
    status: "",
    top_rate_order: 0,
    password: "",
  });
  const [activeTabKey, setActiveTabKey] = useState("info");
  const navigate = useNavigate();

  const handleNextTab = (tab: string) => {
    setActiveTabKey(tab);
  };

  const handleCreateSalon = async () => {
    if (!infoData || !photoData || !settingData) return;
    console.log("=== salonData: ", infoData, photoData, settingData);
    const salonData: SalonRegistration = {
      business: infoData.business,
      address: infoData.address,
      social: infoData.social,
      bank: infoData.bank,
      photo_setting: photoData,
      setting: settingData,
      person_in_charge: infoData.person_in_charge,
    };

    await SalonAPI.createSalon(salonData).then((res) => {
      toast.success("Salon created successfully");
      navigate("/salon");
    }).catch((err) => {
      console.log(" ========= ", err);
      toast.error("Salon created failed");
    });
  };

  const items = [
    {
      label: "Basic Info",
      key: "info",
      children: (
        <InfoTab infoData={infoData} onChange={setInfoData} onNext={handleNextTab}/>
      ),
    },
    {
      label: "Photos",
      key: "Photos",
      children: (
          <Photos data={photoData} onChange={setPhotoData} onNext={handleNextTab} onBack={() => setActiveTabKey("info")}/>
      ),
    },
    {
      label: "Setting",
      key: "setting",
      children: (
      <Settings settingData={settingData} onChange={setSettingData} onCreateSalon={handleCreateSalon}/>
    ),
    },
  ];


  return (
    <Box>
      <Box fontWeight={"bold"} fontSize="24px" mb={2}>
        Add Salon
      </Box>
      <Tabs 
        activeKey={activeTabKey}
        onChange={(key) => setActiveTabKey(key)}
        items={items}
        tabBarStyle={{ borderBottomColor: "var(--app-text)" }}
      />
    </Box>
  );
};

export default AddSalon;
